import underline from "../media/pen-underline.png"
import Nav from "../components/nav";
import FooterComp from "../components/footer";
import "../css/about.css"
import james from "../media/james.jpg"
import { useNavigate } from "react-router-dom";
import useGenStore from "../store/store";
import "aos/dist/aos.css";
import Fonav from "../components/fonnav";
function About() {
  const navigate= useNavigate()
  const menuActive = useGenStore((s)=>s.menuActive)

  const toContact =()=>{
    navigate("/contact")
  }


  return (
    <div>
            <helmet>
        <title>About James McCanna | Employment & Labor Law Attorney</title>
        <meta
          name="description"
          content="Meet James McCanna: 27+ years in employment law, business law, and labor law. Former prosecutor. Free consultation."
        />
      </helmet>
        <div className="floatBtn">
            <button onClick={()=>( window.location.href = "tel:+13602974057")}>Call Now</button>
        </div>
        <div className= {`floatNav ${menuActive ? "floatNavActive":""}`} >
            <Fonav />
        </div>
      <div className="IntroPage">
        <nav>
          <Nav />
        </nav>
        <div className="introWrap">
          <h2>About Me</h2>
          <img src={underline} alt="" />
        </div>
      </div>
<section className="miniAbout">
    <div className="miniAboutPlacer">
        <img src={james} alt="" />
        <div className="jamesDet">
            <h3>James McCanna</h3>
            <span>JD, Owner</span>
        </div>


    </div>

</section>
<section className="mainAbout">
    <div className="mainAboutPlacer">
        
<p>James has been an attorney since 1992 and is deeply versed in employment law, business law, government regulatory compliance and labor law. He believes that all work is honorable. His focus is to promote healthy workplaces, educate employers and protect workers' rights. James encourages employers to recognize the contribution workers make to them and to the economy.</p>

<p>James' background includes working over eleven years as in-house counsel as Senior Employment Practices counsel, where he was responsible for every aspect of his employer's employment program including Wage and Hour, EEOC, OFCCP, DOL regulations. He was also the manager of the EEOC and Training Departments.</p>

<p>He has been in private practice since 2014 with a focus on employment law and business law.</p>

<p>James is a former prosecutor with over a hundred trials under his belt.</p>

<p>James is proud to be an Alaskan Native and a registered shareholder with Chugach Alaska Corporation, an Alaska Native Corporation formed under the Alaska Native Claims Settlement Act. Currently, he is licensed in Washington State and in Alaska.</p>
        <button onClick={()=>toContact()}>Request A Consultation</button>
    </div>

</section>
      <footer>
        <FooterComp />
      </footer>
    </div>
  );
}

export default About;